define('initWestSelectShipping', ['Profile.Model', 'underscore'], function (ProfileModel, _) {
  'use strict';

  return function (wizardView) {
    try {
      var promise = jQuery.Deferred();
      var profile = ProfileModel.getInstance();
      var custentitywest_select_eligible = _.findWhere(profile.get('customfields'), {
        name: 'custentitywest_select_eligible'
      });

      debugger;
      if (custentitywest_select_eligible && custentitywest_select_eligible.value == 'F') {
        var shipMethods = wizardView.model.get('shipmethods');
        shipMethods.models = shipMethods.models.filter(function (model) {
          return model.get('internalid') != '78788';
        });

        wizardView.model.set('shipmethods', shipMethods);
        wizardView.render();
      }

      promise.resolve();

      return promise;
    } catch (err) {
      console.error(205023, err);
    }
  };
});
